import React from "react";
import PlatformSrc from "../../assets/img/brochure/factory-illustration.jpg";
import Reveal from "../common/Reveal";
import CountUp from "../common/CountUp";

const STATS = [
  { value: "10~30%", label: "불량률 감소" },
  { value: "20~40%", label: "설비 다운타임 감소" },
  { value: "15~30%", label: "생산성 향상" },
  { value: "100%", label: "데이터 기반 의사결정" },
];

const ManufacturingInnovation = () => {
  return (
    <section className="bg-primary-50/40 py-16">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
        {/* 텍스트 영역 */}
        <Reveal direction="right">
          <h2 className="break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            당신의 제조 환경을 혁신합니다.
          </h2>
          <p className="mt-5 break-keep text-base leading-relaxed text-gray-600">
            MTST는 산업별 특화된 MES 솔루션, 풍부한 구축 경험, 그리고 최고의
            기술 역량으로 제조 공장의 디지털 전환을 지원합니다. 데이터 기반의
            생산성 향상, 품질관리 강화, 설비 효율 극대화를 통해 고객의 스마트
            제조를 실현합니다.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-6">
            {STATS.map((stat, index) => (
              <Reveal key={stat.label} delay={150 + index * 100}>
                <CountUp
                  text={stat.value}
                  className="text-2xl font-bold text-primary-800 sm:text-3xl"
                />
                <div className="mt-1 text-sm text-gray-600">{stat.label}</div>
              </Reveal>
            ))}
          </div>
        </Reveal>

        {/* 이미지 영역 */}
        <Reveal direction="left" delay={100} className="flex justify-center">
          <div className="rounded-xl bg-white p-8 shadow-lg ring-1 ring-primary-100 transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl">
            <img
              src={PlatformSrc}
              alt="MTST 설비 데이터 수집·AI 분석 플랫폼 구조"
              className="mx-auto w-full max-w-sm"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ManufacturingInnovation;
